import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import getCustomerInfo from "../../services/customerInfo/customerInfo.api";
import { type CustomerInfo } from "../../types/customerInfo";
import { customerInfoActions } from "./slice";
import { withLoader } from "../loader/saga";

// Worker Sagas
export function* onGetCustomerInfo(): SagaIterator {
  try {
    const customerInfos: CustomerInfo[] = yield* withLoader(function* () {
      return yield call(getCustomerInfo);
    });

    yield put(customerInfoActions.fetchAllSucceeded(customerInfos));
  } catch (e: unknown) {
    if (e instanceof Error) {
      yield put(customerInfoActions.fetchAllFailure(e.message.toString()));
    }
  }
}

// Watcher Saga
function* customerInfoWatcherSaga(): SagaIterator {
  yield takeEvery(customerInfoActions.fetchAll.type, onGetCustomerInfo);
}

export default customerInfoWatcherSaga;
